import { formatMoney } from './money'

const PAYMENT_FREQUENCY_TYPE = {
    BIMONTHLY: { en: 'twice a month', es: 'dos semanas' },
    QUARTERLY: { en: 'three months', es: 'tres meses' },
    YEARLY: { en: 'year', es: 'año' },
    OTHER: { en: '{x} month(s)', es: '{x} meses' },
}

const DOCUMENT_TYPE = {
    DRIVERS_LICENSE: { en: 'driver`s license', es: 'licencia de conducir' },
    ID_CARD: { en: 'ID Card', es: 'tarjeta de identificación' },
}

const getUserSpecificPaymentAmount = () => {
    // Priority order: person invitation for current program > program default
    try {
        // For pre-signup users with invitation - find the one matching the current program
        if (window.PERSON?.invitations && window.PROGRAM?.id) {
            const currentProgramInvitation = window.PERSON.invitations.find(
                (invitation) => invitation?.program?.id === window.PROGRAM.id
            )
            if (currentProgramInvitation?.paymentAmount) {
                return currentProgramInvitation.paymentAmount
            }
        }
        // Fall back to program-level amount
        if (window.PROGRAM?.paymentAmount) {
            return window.PROGRAM.paymentAmount
        }
        return null
    } catch {
        return window.PROGRAM?.paymentAmount || null
    }
}

const missingInterpolationHandler = (text: string, value: any) => {
    value[1] = value[1].trim().toLowerCase()
    const userPaymentAmount = typeof window !== 'undefined' ? getUserSpecificPaymentAmount() : null
    const MISSING_INTERPOLATION_VARIABLES = {
        organization_name: typeof window !== 'undefined' ? window.ORGANIZATION.name : '',
        program_duration: typeof window !== 'undefined' ? window.PROGRAM.programDuration[window.S18N.language] : 'en',
        program_name: typeof window !== 'undefined' ? window.PROGRAM.name : '',
        payment_frequency: typeof window !== 'undefined' ? getPaymentFrequency() : '',
        frequency: typeof window !== 'undefined' ? getPaymentFrequency() : '',
        payment_amount: typeof window !== 'undefined' && userPaymentAmount ? formatMoney(userPaymentAmount) : 'N/A',
        amount: typeof window !== 'undefined' && userPaymentAmount ? formatMoney(userPaymentAmount) : 'N/A',
        current_year: new Date().getFullYear(),
        support_email: window.ORGANIZATION_CONFIGS.replyToEmail,
        phone_number: window.ORGANIZATION_CONFIGS.phoneNumber,
        program_url_fragment: window.PERSON?.applicationDetails[0].program?.urlFragment || window.PROGRAM.urlFragment,
    }

    try {
        MISSING_INTERPOLATION_VARIABLES['application_number'] =
            typeof window !== 'undefined' ? window.atob(window?.PERSON?.id)?.split(':')?.[1] : ''
        // eslint-disable-next-line no-empty
    } catch (ignore) {}

    try {
        return MISSING_INTERPOLATION_VARIABLES[value[1]].toString()
    } catch (error) {
        return `MISSING HANDLING FOR ${value[1]}`
    }
}

const getPaymentFrequency = function () {
    try {
        let paymentFrequency = ''
        let numberOfMonths = ''

        paymentFrequency = window.PROGRAM.paymentFrequency
        numberOfMonths = window.PROGRAM.numberOfMonths

        return `${PAYMENT_FREQUENCY_TYPE[paymentFrequency][window.S18N.language]
            .toString()
            .replace('{x}', numberOfMonths)}`
    } catch (error) {
        return 'MISSING_PAYMENT_FREQUENCY'
    }
}

export default missingInterpolationHandler
